import { logger } from '../utils/logger';

/**
 * Utility functions for activity tracking
 */

/**
 * List of URL prefixes that should skip activity tracking
 */
export const noActivityTrackingUrls = [
  '/ff/',                 // Feedback form
  '/feedbackform/',       // Alternative feedback form
  '/student/',            // Student lesson
  '/homeschool/',         // Homeschool pages
  '/unsubscribe/',        // Unsubscribe page
  '/parent/',             // Parent pages
];

/**
 * Check if the current URL should skip activity tracking
 * @returns {boolean} True if activity tracking should be skipped
 */
export const shouldSkipActivityTracking = (): boolean => {
  try {
    // Check if it's the URL shortening app
    const isUrlShortenApp = import.meta.env.VITE_URL_SHORTEN_APP === "true";
    if (isUrlShortenApp) {
      return true;
    }
    
    const pathname = window.location.pathname;
    
    // Check if the URL starts with any of the prefixes in the list
    if (noActivityTrackingUrls.some(prefix => pathname.startsWith(prefix))) {
      return true;
    }
    
    // Check for shortened feedback form URL (4 character ID)
    if (pathname.length > 1 && pathname.match(/^\/[A-Za-z0-9]{4}$/)) {
      return true;
    }
    
    // Default to false (do activity tracking)
    return false;
  } catch (error) {
    logger.error('[Activity] Error checking if should skip activity tracking:', error);
    return false;
  }
};
